export const JOB_CARD_ACTION = {
    EDIT: 'EDIT',
    ARCHIVE: 'ARCHIVE',
    DELETE: 'DELETE',
    CALENDAR: 'CALENDAR'
};
